<template>
    <button
        class="btn-practice-modes"
        @click="routePracticeModes">
        <span class="btn-practice-modes__text">PRATİK</span>
    </button>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        methods:{
            routePracticeModes(){
                this.$router.push('/practice-modes');
            }
        }
    };
</script>

<style scoped src="@/css/components/btn-practice-modes.css"></style>